<div class="modal-generico">
  <ds-content-sheet [visible]="sheetVisible" [title]="title" [maxWidth]="400" [dismissOnBackdropClick]="true"
    (dismissed)="sheetVisible = false">

    <p class="ds-text-body-regular">
      {{ subtitle }}
    </p>

    <div ds-content-sheet-footer [style.width.%]="100">
      <div class="modal-generico__acciones">
        <ds-button-v2 [label]="primaryButtonText" [fullWidth]="true" (click)="goToPage()">
        </ds-button-v2>
      </div>
    </div>
  </ds-content-sheet>
</div>